import React from "react";
export default () => (React.createElement("div", { className: "repeat-m-half" },
    React.createElement("div", { "data-ecom-spinner": "center third-party" },
        React.createElement("div", { className: "spinner" }))));
